import { useState, type FC } from 'react';
import { ActionIcon, Drawer } from '@mantine/core';
import { useUnit } from 'effector-react';
import { NewPayinTickets, PayinTicketsList } from '~/features/payin';
import { NewPayoutTickets, PayoutTicketsList } from '~/features/payout';
import { PayinTicketStatus } from '~/entities/payin';
import { PayoutTicketStatus } from '~/entities/payout';
import { $mode } from '~/shared/store/mode';
import { payinTicketPaginationModel, payoutTicketPaginationModel } from '../../model';
import styles from './TicketCenter.module.css';

export const TicketCenter: FC = () => {
    const mode = useUnit($mode);
    const [open, setOpen] = useState(false);

    return (
        <>
            <ActionIcon
                aria-label='Новые заявки'
                aria-expanded={open}
                className={styles.action}
                onClick={() => setOpen((prev) => !prev)}
                size='xl'
                variant='subtle'
            >
                {mode === 'payin' ? <NewPayinTickets /> : <NewPayoutTickets />}
            </ActionIcon>

            <Drawer
                opened={open}
                withCloseButton
                position='right'
                onClose={() => setOpen(false)}
                title='Новые заявки'
            >
                {mode === 'payin' ? (
                    <PayinTicketsList
                        paginationModel={payinTicketPaginationModel}
                        filter={{ statuses: [PayinTicketStatus.STATUS_CREATED] }}
                    />
                ) : (
                    <PayoutTicketsList
                        paginationModel={payoutTicketPaginationModel}
                        filter={{ statuses: [PayoutTicketStatus.STATUS_CREATED] }}
                    />
                )}
            </Drawer>
        </>
    );
};
